<template>
  <div class="modal" @mousedown.self="hideModal()">
    <div :class="`modal-dialog ${size ? 'modal-dialog-' + size :''} ${classNames ? classNames :''}`">
      <div class="popup-header" :class="{'-align-end': !$slots['header'], '-between': $slots['header'] && !hideclose} " :style="{'padding-bottom': lowheader ? '0' : 'auto'}">
        <slot name="header"></slot>
        <span v-if="!hideclose" class="modal-close" @click="hideModal()">
          <svg class="modal-close-icon"><use xlink:href="#icon-close"></use></svg>
        </span>
      </div>
      <div class="modal-content" :style="{'padding-top': lowheader ? '0' : 'auto'}">
        <div class="popup-section">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal",
  props: ['size', 'classNames', 'lowheader', 'hideclose'],
  methods: {
    hideModal() {
      this.$emit('hidemodal')
    },
  }
}
</script>

<style lang="scss">
.welcome-modal {
  background: linear-gradient(331.33deg, #CFD1F4 11.55%, #EFF1FF 51.74%), #FFFFFF;

  .modal-content {
    background: none;
  }
}
.modal-close-icon {
  width: 20px;
  height: 20px;
}
</style>